query CompanyChartOfAccounts($filter: CompanyChartOfAccountFilter) {
  companyChartOfAccounts(filter: $filter, orderBy: NAME_ASC) {
    nodes {
      id
      name
      _isCorporate
    }
  }
}
